import WalasFormModal from "./WalasFormModal";

export default function AddWalas(props) {
  return <WalasFormModal {...props} mode="create" />;
}
